import gql from '@/services/gql';
import { Price } from '@/services/price/types';
import query from './query';

const updateQuery = gql(query);

const updateResource = (
  vendor: any,
  resourceName: string,
) => ({
  data: (vendor[`${resourceName}s`] || [])
    .map((resource: any) => ({
      ...resource,
      [`${resourceName}_id`]: resource[resourceName].id,
      // remove linked record
      [resourceName]: undefined,
    }),
  ),
  on_conflict: {
    constraint: `vendor_${resourceName}_pkey`,
    update_columns: [
      `${resourceName}_id`,
      'properties',
    ],
  },
});

export default (
  vendorId: string,
  {
    vendor = {} as any,
    deleteComponentIds = [] as any,
    deleteMaterialIds = [] as any,
    priceRemoveIds = [] as string[],
    prices = [] as Price[],
  },
) => (
  updateQuery({
    vendor: {
      ...vendor,
      id: vendorId,
      components: updateResource(vendor, 'component'),
      materials: updateResource(vendor, 'material'),

      // remove views
      prices: undefined,
    },
    delete_component_ids: deleteComponentIds,
    delete_material_ids: deleteMaterialIds,

    // update price (view)
    prices,
    priceRemoveIds,
  })
  .then((response: any) => {
    const { affected_rows: vendorResult } = response.insert_vendor;
    const { affected_rows: component } = response.delete_vendor_component;
    const { affected_rows: material } = response.delete_vendor_material;

    if (!vendorResult && !component && !material) {
      throw {
        code: `VENDOR_NOT_UPDATED`,
      };
    }
    return response;
  })
);
